import { api } from "@/utils/api";
import { createMetaConversionPayload, fireMetaPixelEvent } from "@/utils/metaPixel";
import { loginUser } from "@/features/user/userSlice";
import { toast } from "@/utils/appToast";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import PhoneInput from 'react-phone-input-2'
import type { User } from "@/types/userTypes";
import 'react-phone-input-2/lib/style.css'
import { useTranslation } from 'react-i18next';
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import { IconButton } from "@mui/material";
import GoogleSignUp from '@/utils/googleSignup'

function RegisterContractorForm({ handlePopupType, onSuccess }) {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [selectedService, setSelectedService] = useState<string>("");
    const [otherService, setOtherService] = useState<string>("");
    const [availability, setAvailability] = useState<string>("");
    const [serviceCategories, setServiceCategories] = useState([]);
    const [selectedCategoryId, setSelectedCategoryId] = useState<string>("");
    const [categoryServices, setCategoryServices] = useState([]);
    const [phone, setPhone] = useState('');
    const [phoneError, setPhoneError] = useState('');
    const [showPassword, setShowPassword] = useState({
    password: false,
    repeatPassword: false,
});



    useEffect(() => {
        const fetchOptions = async () => {
            try {
                const fetchedServiceCategories = await api.getServiceCategories();
                setServiceCategories(fetchedServiceCategories);
            } catch (err) {
                console.error("Failed to fetch options:", err);
            }
        };

        fetchOptions();
    }, [i18n.language]);


    useEffect(() => {
        const selectedCategory = serviceCategories.find(cat => cat._id === selectedCategoryId);
        setCategoryServices(selectedCategory?.services || []);
    }, [selectedCategoryId, serviceCategories]);


    const closeModal = useRef();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    // const dispatch = useDispatch();

    const validateEmail = (email: string): boolean => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleRegister = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const registerForm = e.target as HTMLFormElement;
        const registerData = new FormData(registerForm);

        let newUser = {
            first_name: registerData.get("first_name") as string,
            last_name: registerData.get("last_name") as string,
            email: registerData.get("email") as string,
            password: registerData.get("password") as string,
            phone: '+' + phone,
            type: undefined,
        };

        setIsLoading(true);
        try {
            const meta = createMetaConversionPayload();
            const { status, data } = await api.signUp({
                ...newUser,
                ...meta,
            });
            setIsLoading(false);

            if (status === "error") {
                return toast.error(data.message);
            }
            fireMetaPixelEvent("CompleteRegistration", meta.eventId);
            if (onSuccess) {
                onSuccess(); // This will trigger popup close
            }
            toast.success("User created successfully. Thank you for registering. A verification email has been sent to your email. Please verify your email to log in.");
            registerForm.reset();
            setSelectedCategoryId("");
            setSelectedService("");
            setOtherService("");
            setAvailability("");
            setPhone('');
            setPhoneError('');
            handlePopupType('Close');
        } catch (error) {
            setIsLoading(false);
            toast.error("Error registering user. Please try again.");
        }
    };
    const fields = [
        {
            id: "registerUserName",
            type: "text",
            name: "first_name",
            placeholder: "Nombre",
            label: "Nombre",
        },
        {
            id: "registerUserLastname",
            type: "text",
            name: "last_name",
            placeholder: "Apellido",
            label: "Apellido",
        },
        {
            id: "registerUserEmail",
            type: "text",
            name: "email",
            placeholder: "Email",
            label: "Email",
        },
        {
            id: "registerUserPassword",
            type: "password",
            name: "password",
            placeholder: "Contraseña",
            label: "Contraseña",
        },
        {
            id: "registerUserRepeatPassword",
            type: "password",
            name: "repeatPassword",
            placeholder: "Repetir Contraseña",
            label: "Repetir Contraseña",
        },
    ];

    return (
        <>
            <form onSubmit={handleRegister}>
                <div className="form-group">
                    {/* First Name and Last Name in same row */}
                    <div className="row mb-5">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label htmlFor="registerUserName" style={{ color: "white" }}>
                                    {t('firstName')} <span style={{ color: "red" }}> *</span>
                                </label>
                                <input
                                    id="registerUserName"
                                    name="first_name"
                                    type="text"
                                    placeholder={t('firstName')}
                                    style={{ borderRadius: 0 }}
                                    required
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label htmlFor="registerUserLastname" style={{ color: "white" }}>
                                    {t('lastName')} <span style={{ color: "red" }}> *</span>
                                </label>
                                <input
                                    id="registerUserLastname"
                                    name="last_name"
                                    type="text"
                                    placeholder={t('lastName')}
                                    style={{ borderRadius: 0 }}
                                    required
                                />
                            </div>
                        </div>
                    </div>

                    {/* Phone field with react-phone-input-2 */}
                    <div className="form-group">
                        <label htmlFor="registerUserPhone" style={{ color: "white" }}>
                            {t('phone')} <span style={{ color: "red" }}> *</span>
                        </label>
                        <PhoneInput
                            country={'us'}
                            countryCodeEditable={false}
                            value={phone}
                            onChange={value => {
                                setPhone(value);
                                setPhoneError('');
                            }}
                            inputProps={{
                                name: 'phone',
                                required: true,
                                id: 'registerUserPhone',
                                style: { flex: 6, borderRadius: 0, width: '100%', minHeight: '60px', fontSize: '14px' }
                            }}
                            inputStyle={{
                                width: '100%',
                                borderRadius: 0,
                                minHeight: '60px',
                                fontSize: '14px'
                            }}
                            buttonStyle={{
                                borderRadius: 0
                            }}
                            containerStyle={{
                                width: '100%'
                            }}
                            specialLabel=""

                            disableDropdown={false}
                            onlyCountries={['us']}
                            onBlur={() => {
                                if (phone && phone.replace(/\D/g, '').length < 11) setPhoneError('Por favor ingrese un número de teléfono válido.');
                            }}
                        />
                        {/* {phoneError && <div style={{ color: 'red', fontSize: 12 }}>{phoneError}</div>} */}
                    </div>

                    {/* Rest of the fields */}
                {fields.slice(2).map((field) => {
    const isPasswordField = field.name === "password" || field.name === "repeatPassword";

    return (
        <div key={field.id} className="form-group">
            <label htmlFor={field.id} style={{ color: "white" }}>
                {t(
                    field.name === "email"
                        ? "email"
                        : field.name === "password"
                        ? "password"
                        : field.name === "repeatPassword"
                        ? "repeatPassword"
                        : field.label
                )}{" "}
                <span style={{ color: "red" }}> *</span>
            </label>

            <div className="d-flex gap-2" style={{ position: "relative" }}>
                {/* NORMAL INPUTS */}
                {!isPasswordField ? (
                    <input
                        id={field.id}
                        name={field.name}
                        type={field.type}
                        placeholder={t(
                            field.name === "email"
                                ? "email"
                                : field.placeholder
                        )}
                        style={{ flex: 6, borderRadius: 0 }}
                        required
                        autoComplete="email"
                    />
                ) : (
                    /* PASSWORD INPUT WITH MUI ICON BUTTON */
                    <div style={{ flex: 6, position: "relative" }}>
                        <input
                            id={field.id}
                            name={field.name}
                            type={showPassword[field.name] ? "text" : "password"}
                            placeholder={t(
                                field.name === "password"
                                    ? "password"
                                    : "repeatPassword"
                            )}
                            style={{ width: "100%", borderRadius: 0 }}
                            required
                            autoComplete="new-password"
                        />

                        <IconButton
                            onClick={() =>
                                setShowPassword((prev) => ({
                                    ...prev,
                                    [field.name]: !prev[field.name],
                                }))
                            }
                            style={{
                                position: "absolute",
                                right: 5,
                                top: "50%",
                                transform: "translateY(-50%)",
                                padding: 0,
                                color: "black",
                            }}
                        >
                            {showPassword[field.name] ? (
                                <VisibilityOff />
                            ) : (
                                <Visibility />
                            )}
                        </IconButton>
                    </div>
                )}
            </div>
        </div>
    );
})}






                    {/* Select Service */}



                    {/* Show otherService input if selected */}
                    {selectedService === "other" && (
                        <div className="form-group">
                            <label style={{ color: "white" }}>{t('other')} {t('service')}</label> <span style={{ color: "red" }}> *</span>
                            <input
                                type="text"
                                name="otherService"
                                className="form-control"
                                placeholder={t('enterDescription')}
                                value={otherService}
                                onChange={(e) => setOtherService(e.target.value)}
                                required
                            />
                        </div>
                    )}
                    <div className="flex items-center gap-2 mb-2">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id={'termofuse'}
                            required
                        />
                        <p  className="text-white">
                            {t("confimation")} 
                            <a href="/politica-de-privacidad" className="text-white underline mx-1" target="_blank" rel="noopener noreferrer">{t("privacyPolicy")}</a>
                             {t("and")} 
                            <a href="/terminos-de-uso" className="text-white underline mx-1" target="_blank" rel="noopener noreferrer">{t("termOfUse")}</a>.
                        </p>
                        <GoogleSignUp
  type="client"
  onSuccess={(user) => {
    // Check if essential info needs to be completed
    const hasPhone = user?.phone && user.phone.trim() !== '';
    const isEssentialCompleted = user?.isEssentialCompleted === true;
    const needsEssentialInfo = !isEssentialCompleted || !hasPhone;
    
    if (needsEssentialInfo) {
      // Redirect to complete essential info page
      navigate("/complete-essential-info", {
        state: {
          userType: "client"
        }
      });
      handlePopupType('Close');
    } else {
      // Close popup and continue
      if (onSuccess) {
        onSuccess();
      }
      handlePopupType('Close');
    }
  }}
/>


                    </div>


                    <button
                        className="theme-btn btn-style-one"
                        type="submit"
                        disabled={isLoading}
                        style={{ backgroundColor: "black" }}
                    >
                        {isLoading ? (
                            <div
                                className="spinner-border"
                                style={{ height: "15px", width: "15px" }}
                                role="status"
                            ></div>
                        ) : (
                            t('register')
                        )}
                    </button>
                </div>
            </form>


        </>
    )
}
export default RegisterContractorForm